<template>
    <v-row no-gutters>
        <v-col
            cols="12"
            style="position: relative; overflow-y: hidden; border-radius: 15px"
            @mouseover="displayScrollToBtn()"
            @mouseleave="hideScrollToBtn()"
        >
            <div
                class="table-responsive"
                :style="`height: fit-content; overflow-y: auto; max-height: ${height}; max-width: ${width}`"
                :id="`infinite-list-${random}`"
            >
                <table :class="tableClass" :data-cy="prefixCy + '_table'">
                    <thead :class="getHeadClass()">
                        <slot name="header" :headers="headers">
                            <tr style="z-index: 2; position: relative; border: none">
                                <th
                                    v-if="showSelect"
                                    scope="col"
                                    :class="getTheadClasses()"
                                    align="center"
                                    justify="left"
                                    style="padding: 0px 8px"
                                >
                                    <slot name="header.data-table-select">
                                        <v-checkbox-btn
                                            :color="checkBoxColor"
                                            density="comfortable"
                                            class="pa-0 ma-0 mx-2"
                                            hide-details
                                            :indeterminate="isIndeterminate"
                                            :dense="xDense"
                                            @click="selectAll"
                                            :ripple="false"
                                            :model-value="isAllSelect"
                                        />
                                    </slot>
                                </th>
                                <th
                                    v-for="(header, index) of headers"
                                    :key="index"
                                    :class="getTheadClasses(header)"
                                    :align="header && header.align ? header.align : 'left'"
                                    :style="`width: ${
                                        header && header.width ? header.width : 'auto'
                                    }`"
                                >
                                    <v-row no-gutters style="flex-wrap: nowrap">
                                        <v-col class="flex-grow-1 flex-shrink-0">
                                            <slot
                                                :name="`header.${
                                                    header && header.value ? header.value : ''
                                                }`"
                                                :headers="headers"
                                                :header="header"
                                            >
                                                {{ header ? (getHeaderTitle(header) ?? "") : "" }}
                                            </slot>
                                        </v-col>
                                        <v-col class="flex-grow-0 flex-shrink-1">
                                            <v-btn-icon
                                                v-if="header.sortable"
                                                :icon="getSortIcon(header.value)"
                                                @click="
                                                    sort(header && header.value ? header.value : '')
                                                "
                                                size="x-small"
                                            >
                                            </v-btn-icon>
                                            <v-menu
                                                v-if="header.filterable"
                                                v-model="
                                                    filters[
                                                        header && header.value ? header.value : ''
                                                    ]
                                                "
                                                offset-y
                                                :close-on-content-click="false"
                                                location="start"
                                            >
                                                <template v-slot:activator="{ props }">
                                                    <v-btn-icon
                                                        icon="$fa-filter"
                                                        size="x-small"
                                                        v-bind="props"
                                                        @click.stop
                                                    />
                                                </template>
                                                <div class="filter-menu">
                                                    <template
                                                        v-if="
                                                            header.filterable.options &&
                                                            header.filterable.options.input ===
                                                                'date'
                                                        "
                                                    >
                                                        <template
                                                            v-if="
                                                                header.filterable.options
                                                                    .inputType === 'date-picker'
                                                            "
                                                        >
                                                            <oss-date-picker-filled
                                                                v-model="
                                                                    filter[
                                                                        header && header.value
                                                                            ? header.value
                                                                            : ''
                                                                    ]
                                                                "
                                                                hide-details
                                                                :textFieldReadOnly="false"
                                                                type="month"
                                                            />
                                                        </template>
                                                        <template v-else>
                                                            <v-text-field-filled
                                                                v-model="
                                                                    filter[
                                                                        header && header.value
                                                                            ? header.value
                                                                            : ''
                                                                    ]
                                                                "
                                                                outlined
                                                                dense
                                                                hide-details
                                                                autofocus
                                                            >
                                                                <template v-slot:append>
                                                                    <v-btn-icon
                                                                        icon="$fa-times"
                                                                        size="small"
                                                                        @click="
                                                                            clearFilter(
                                                                                header &&
                                                                                    header.value
                                                                                    ? header.value
                                                                                    : '',
                                                                            )
                                                                        "
                                                                        @keypress.enter="
                                                                            filter[
                                                                                header &&
                                                                                header.value
                                                                                    ? header.value
                                                                                    : ''
                                                                            ] = false
                                                                        "
                                                                    />
                                                                </template>
                                                            </v-text-field-filled>
                                                        </template>
                                                    </template>
                                                    <template
                                                        v-else-if="
                                                            header.filterable.type === 'equals'
                                                        "
                                                    >
                                                        <v-combobox
                                                            class="border rounded-xl"
                                                            v-model="
                                                                filter[
                                                                    header && header.value
                                                                        ? header.value
                                                                        : ''
                                                                ]
                                                            "
                                                            :items="comboBoxItemsList(header)"
                                                            :item-title="
                                                                header.filterable.options.toText
                                                            "
                                                            multiple
                                                            dense
                                                            outlined
                                                            clearable
                                                            hide-details
                                                            chips
                                                        >
                                                        </v-combobox>
                                                    </template>
                                                    <template v-else>
                                                        <v-text-field-filled
                                                            v-model="
                                                                filter[
                                                                    header && header.value
                                                                        ? header.value
                                                                        : ''
                                                                ]
                                                            "
                                                            outlined
                                                            dense
                                                            hide-details
                                                            autofocus
                                                        >
                                                            <template v-slot:append>
                                                                <v-btn-icon
                                                                    icon="$fa-times"
                                                                    size="small"
                                                                    @click="
                                                                        clearFilter(
                                                                            header && header.value
                                                                                ? header.value
                                                                                : '',
                                                                        )
                                                                    "
                                                                    @keypress.enter="
                                                                        filter[
                                                                            header && header.value
                                                                                ? header.value
                                                                                : ''
                                                                        ] = false
                                                                    "
                                                                />
                                                            </template>
                                                        </v-text-field-filled>
                                                    </template>
                                                </div>
                                            </v-menu>
                                            <v-icon
                                                v-if="header.editable"
                                                color="primary"
                                                size="x-small"
                                                icon="$oss-edit"
                                            >
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </th>
                            </tr>
                        </slot>
                        <slot
                            name="header.append"
                            :headers="headers"
                            :style="`height: fit-content; top: ${
                                computedRowHeight + 2
                            }px; padding: 0px !important`"
                            :class="getTheadClasses()"
                        >
                        </slot>
                        <tr
                            v-if="loading || scrollToInProgress"
                            style="z-index: 1; position: relative"
                        >
                            <th
                                colspan="100"
                                align="center"
                                :style="`height: fit-content; top: ${computedRowHeight}px; padding: 0px !important`"
                                :class="getTheadClasses()"
                            >
                                <v-progress-linear
                                    indeterminate
                                    class="mx-0"
                                    :color="checkBoxColor"
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="filtredItems && filtredItems.length">
                        <template v-for="(item, index) of filtredItems">
                            <slot
                                name="item"
                                :item="item"
                                :index="index"
                                :isSelected="isSelected(item)"
                                :onSelect="() => addRemoveItem(item, index)"
                            >
                                <tr
                                    :key="index"
                                    :class="getTrClasses(item)"
                                    :style="getRowStyle(index)"
                                    @click.stop="onClick(item)"
                                    @contextmenu="show($event, item)"
                                    v-ripple
                                    :data-cy="prefixCy + '_table_' + index"
                                >
                                    <td
                                        v-if="showSelect"
                                        :class="getCellClasses()"
                                        :align="
                                            headers && headers[index] && headers[index].align
                                                ? headers[index].align
                                                : 'center'
                                        "
                                    >
                                        <slot
                                            name="item.checkbox"
                                            :item="item"
                                            :isSelected="isSelected(item)"
                                            :onSelect="() => addRemoveItem(item, index)"
                                        >
                                            <v-checkbox
                                                v-if="cbDisplayCondition(item)"
                                                hide-details
                                                class="pa-0 my-0 mx-2"
                                                :color="checkBoxColor"
                                                :ripple="false"
                                                :dense="xDense"
                                                @click.stop="addRemoveItem(item, index)"
                                                :model-value="isSelected(item)"
                                            />
                                        </slot>
                                    </td>
                                    <td
                                        v-for="(header, hIndex) of headers"
                                        :class="getCellClasses(header)"
                                        :key="hIndex"
                                        :align="header && header.align ? header.align : 'left'"
                                    >
                                        <slot
                                            :name="
                                                'item.' +
                                                (header && header.value ? header.value : '')
                                            "
                                            :item="item"
                                            :index="index"
                                            :header="header"
                                            :hIndex="hIndex"
                                        >
                                            <template v-if="header.editable">
                                                <input
                                                    v-model="
                                                        item[
                                                            header && header.value
                                                                ? header.value
                                                                : ''
                                                        ]
                                                    "
                                                    type="text"
                                                    class="input-table"
                                                />
                                            </template>
                                            <template v-else-if="header.select">
                                                <v-checkbox
                                                    v-if="cbDisplayCondition(item)"
                                                    hide-details
                                                    class="pa-0 my-0 mx-2"
                                                    :color="checkBoxColor"
                                                    :ripple="false"
                                                    :dense="xDense"
                                                    @click.stop="addRemoveItem(item, index)"
                                                    :model-value="isSelected(item)"
                                                />
                                            </template>
                                            <div v-else>
                                                {{
                                                    item[header && header.value ? header.value : ""]
                                                }}
                                            </div>
                                        </slot>
                                    </td>
                                </tr>
                            </slot>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr style="background: #fff">
                            <td :colspan="headers.length + (showSelect ? 1 : 0)">
                                <slot name="no-data">Aucune donnée disponible</slot>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot
                        :class="{
                            'fixed-footer': fixedFooter,
                        }"
                    >
                        <slot name="body.append" />
                        <tr v-if="haveSum">
                            <td v-if="showSelect" :class="getTheadClasses()" />
                            <td
                                v-for="(header, hIndex) of headers"
                                :class="getTheadClasses(header)"
                                :key="hIndex"
                                :align="header && header.align ? header.align : 'left'"
                            >
                                <slot
                                    v-if="header.sum"
                                    :name="'sum.' + (header && header.value ? header.value : '')"
                                    :sum="getSum(header && header.value ? header.value : '')"
                                    :header="header"
                                    :hIndex="hIndex"
                                >
                                    {{ getSum(header && header.value ? header.value : "") }}
                                </slot>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <!-- button to scroll automaticly to the top/bottom of the table -->
            <div
                v-if="scrollToBtnConfig && items.length > rowToShow && isScrollToBtnVisible"
                class="scroll-to-btns"
            >
                <v-tooltip v-if="scrollToBtnConfig.up" location="top">
                    <template v-slot:activator="{ props }">
                        <v-btn
                            v-bind="props"
                            rounded
                            size="x-small"
                            color="white"
                            class="scroll-to-top-btn"
                            :disabled="scrollToInProgress"
                            @click="scrollTo('top')"
                        >
                            <v-icon>$fa-arrow-left</v-icon>
                        </v-btn>
                    </template>
                    <span>Remonter à la première ligne</span>
                </v-tooltip>
                <v-tooltip v-if="scrollToBtnConfig.down" location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn
                            v-bind="props"
                            rounded
                            size="x-small"
                            color="white"
                            class="scroll-to-bottom-btn"
                            :disabled="scrollToInProgress"
                            @click="scrollTo('bottom')"
                        >
                            <v-icon>$fa-arrow-left</v-icon>
                        </v-btn>
                    </template>
                    <span>Descendre à la dernière ligne</span>
                </v-tooltip>
            </div>
            <!-- this button is visible when the props scrollToBtnConfig is defined and the mouse is over the table -->
        </v-col>
        <v-col cols="12" class="d-flex justify-end text--secondary" v-if="displayRowNumber">
            <template v-if="itemKeysSelected.length">{{ itemKeysSelected.length }} /</template
            >{{ itemLength || items.length }}
            éléments
        </v-col>
        <v-menu
            v-model="showMenu"
            :target="[x, y]"
            absolute
            offset-y
            min-width="250px"
            v-if="selectedMenuItem"
        >
            <slot
                name="menu"
                :index="getIndex(selectedMenuItem)"
                :item="selectedMenuItem"
                :close="closeMenu"
            />
        </v-menu>
    </v-row>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Model, toNative } from "vue-facing-decorator";
import { orderBy, uniq } from "lodash";
import moment from "moment-timezone";

@Component({
    components: {},
    emits: ["sort", "update:sort-by", "update:sort-desc", "load-more", "selectAll", "clickRow"],
})
export class ossDataTable2 extends Vue {
    @Prop() headers!: Header[];
    @Prop() items!: any[];

    @Prop({ default: "80vh" }) height: string;
    @Prop({ default: "auto" }) width: any;
    @Prop({ default: false }) striped: boolean;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: false }) tableHover: boolean;
    @Prop({ default: false }) fixedHeader: boolean;
    @Prop({ default: false }) fixedFooter: boolean;
    @Prop({ default: false }) hideDefaultHeader: boolean;
    @Prop({ default: false }) hideDefaultFooter: boolean;
    @Prop({ default: false }) dense: boolean;
    @Prop({ default: false }) xDense: boolean;
    @Prop({ default: false }) showSelect: boolean;
    @Prop({ default: null }) rowHeight: number;
    @Prop({ default: 30 }) rowToShow: number;
    @Prop({ default: "id" }) itemKey: string;
    @Prop({ default: null }) itemLength: number;
    @Prop({ default: false }) displayRowNumber: boolean;
    @Prop({ default: false }) virtualScroll: boolean;
    @Prop({ default: null }) sortBy: string[];
    @Prop({ default: null }) sortDesc: string[];
    @Prop({ default: "primary" }) checkBoxColor: string;
    @Prop({ default: null }) checkboxDisplayCondition: (item: any) => boolean;
    @Prop({ default: null }) rowStyles: any;
    @Prop({ default: "" }) prefixCy: string;
    @Prop({ default: null }) scrollToBtnConfig?: { up: boolean; down: boolean } | null;
    @Prop({ default: null }) headerTitle: string | ((header: any) => string);

    @Model() value!: any[];

    sectionShowed = 0;

    sort_ = "";

    random = "";

    lastSelected;

    majPress = false;
    ctrlPress = false;

    showMenu = false;
    selectedMenuItem = null;
    itemKeysSelected = [];

    poolSize = 25;

    filters = {};

    x = 0;
    y = 0;

    get isAllSelect() {
        if (this.isIndeterminate) {
            return true;
        }
        if (this.itemLength) {
            return this.itemKeysSelected.length === this.itemLength;
        }
        return this.itemKeysSelected.length === this.items.length;
    }

    get itemsSelected() {
        if (this.itemKeysSelected.length) {
            return this.filtredItems.filter((item) =>
                this.itemKeysSelected.includes(item[this.itemKey]),
            );
        }
        return [];
    }

    get customHeader() {
        return this.$slots.header || this.$slots.header();
    }

    customItemLine() {
        return !!this.$slots.item || !!this.$slots.item();
    }

    get isIndeterminate() {
        if (this.itemLength) {
            return (
                this.itemKeysSelected.length > 0 && this.itemKeysSelected.length < this.itemLength
            );
        }
        return this.itemKeysSelected.length > 0 && this.itemKeysSelected.length < this.items.length;
    }

    get calcHeightTable() {
        return `${this.height}`;
    }

    get tableClass() {
        return {
            table: true,
            "table-striped": this.striped,
            "table-fixed-header": this.fixedHeader,
            "table-fixed-footer": this.fixedFooter,
            "table-hover": this.tableHover,
            "user-select-disabled": this.showSelect,
            "x-dense": this.xDense,
            dense: this.dense,
        };
    }

    get haveSum() {
        if (this.headers?.length) {
            return this.headers.some((header) => header.sum);
        }
        return false;
    }

    get filtredItems() {
        let items = this.items || [];
        for (const key in this.filter) {
            if (this.filter[key] && this.filter[key].length) {
                const header = this.headers.find((header) => header?.value === key);
                if (header?.filterable?.options?.input) {
                    const input = header.filterable.options.input;
                    switch (input) {
                        case "date": {
                            if (header.filterable.options.inputType === "date-picker") {
                                items = items.filter((item) => {
                                    const itemDate = moment(item[key]);
                                    const filterDate = moment(this.filter[key]);
                                    if (itemDate.isValid() && filterDate.isValid()) {
                                        return itemDate.isBetween(
                                            filterDate,
                                            filterDate.endOf("month"),
                                        );
                                    }
                                    return true;
                                });
                            } else {
                                items = items.filter((item) => {
                                    if (item[key]) {
                                        const itemDate = moment(item[key]).format("DD-MM-YYYY");
                                        const filterDate = this.filter[key].replace(/\//g, "-");
                                        return itemDate
                                            .toString()
                                            .toLowerCase()
                                            .includes(filterDate.toLowerCase());
                                    }
                                    return false;
                                });
                            }
                            break;
                        }
                    }
                } else if (header.filterable.type.toLowerCase() === "startwith") {
                    items = items.filter(
                        (item) =>
                            item[key] &&
                            item[key]
                                .toString()
                                .toLowerCase()
                                .startsWith(this.filter[key].toLowerCase()),
                    );
                } else if (header.filterable.type.toLowerCase() === "includes") {
                    items = items.filter(
                        (item) =>
                            item[key] &&
                            item[key]
                                .toString()
                                .toLowerCase()
                                .includes(this.filter[key].toLowerCase()),
                    );
                } else if (
                    header.filterable.type.toLowerCase() === "equals" &&
                    this.filter[key]?.length
                ) {
                    if (header.filterable.options.customFilter) {
                        items = header.filterable.options.customFilter(items, this.filter[key]);
                    } else {
                        const toCompare = this.filter[key].map((x) => x.value);
                        items = items.filter(
                            (item) =>
                                (item[key] || item[key] === "") &&
                                toCompare.includes(item[key].toString()),
                        );
                    }
                }
            }
        }
        if (this.sort_) {
            const [value, direction] = this.sort_.split("-");
            return orderBy(items, [value], [direction as "asc" | "desc"]);
        }
        if (this.virtualScroll) {
            items = items.slice(0, this.poolSize);
        }
        return items;
    }

    get computedRowHeight() {
        if (this.rowHeight) {
            return this.rowHeight;
        }
        if (this.dense) {
            return 32;
        }
        if (this.xDense) {
            return 26;
        }
        return 48;
    }

    filter = {};

    /**
     * Get displayed header title.
     * If itemTitle prop is not set, it uses the title key and falls back on the text key
     * @param header
     */
    getHeaderTitle(header: Header): string {
        if (this.headerTitle && typeof this.headerTitle === "function") {
            return this.headerTitle(header);
        } else if (this.headerTitle && typeof this.headerTitle === "string") {
            return header[this.headerTitle];
        }
        return header.title ?? header.text;
    }

    cbDisplayCondition(item) {
        if (this.checkboxDisplayCondition) {
            return this.checkboxDisplayCondition(item);
        }
        return true;
    }

    comboBoxItemsList(header) {
        if (header.filterable?.options?.values) {
            return header.filterable.options.values;
        }
        let items = uniq(this.items.map((item) => item[header?.value]));

        if (header.filterable?.options?.toText) {
            items = items.map((item) => ({
                text: header.filterable.options.toText(item),
                value: item,
            }));
        } else {
            items = items.map((item) => ({
                text: item,
                value: item,
            }));
        }
        if (header.filterable?.options?.sort) {
            items = orderBy(items, [header.filterable?.options?.sort], ["asc"]);
        }
        return items;
    }

    sort(input: string) {
        const [value, direction] = this.sort_.split("-");
        if (value === input) {
            if (direction === "asc") {
                this.sort_ = input + "-desc";
            } else {
                this.sort_ = "";
            }
        } else {
            this.sort_ = input + "-asc";
        }
        this.$emit("sort", this.sort_);
        this.$emit("update:sort-by", [value]);
        this.$emit("update:sort-desc", [direction]);
    }

    getTrClasses(item: any) {
        // console.log("isSelected:", this.isSelected(item[this.itemKey]))
        return {
            "row-selected": this.isSelected(item),
        };
    }

    getTheadClasses(header: Header = null) {
        if (header) {
            return {
                "vertical-sticky": header.verticalSticky || false,
                header: true,
                "vertical-sticky-end": header.verticalStickyEnd || false,
            };
        }
        return {
            header: true,
        };
    }

    getRowStyle(index: number) {
        if (this.rowStyles?.length && index < this.rowStyles.length) {
            return this.rowStyles[index];
        }
        return "";
    }

    getIndex(value: any) {
        return this.items.findIndex((item) => this.isEqual(item, value));
    }

    addRemoveItem(item, index) {
        if (this.majPress) {
            const minIndex = Math.min(index, this.lastSelected);
            const maxIndex = Math.max(index, this.lastSelected);

            const itemsToSelect = this.filtredItems
                .slice(minIndex, maxIndex + 1)
                .filter((item) => this.cbDisplayCondition(item));
            console.log("itemsToSelect", itemsToSelect);
            const keysSelection = itemsToSelect.map((item) => item[this.itemKey]);

            if (keysSelection.every((key) => this.itemKeysSelected.includes(key))) {
                this.itemKeysSelected = this.itemKeysSelected.filter(
                    (el) => keysSelection.indexOf(el) < 0,
                );
            } else {
                console.log("keysSelection", keysSelection);
                for (const key of keysSelection) {
                    if (!this.itemKeysSelected.includes(key)) {
                        this.itemKeysSelected.push(key);
                    }
                }
            }
        } else {
            const itemKey = item[this.itemKey];
            if (this.itemKeysSelected.includes(itemKey)) {
                this.itemKeysSelected = this.itemKeysSelected.filter((key) => key !== itemKey);
            } else {
                this.itemKeysSelected.push(itemKey);
            }
        }
        this.lastSelected = index;
        // console.log("itemKeysSelected", this.itemKeysSelected)
        this.onitemKeysSelectedChange();
    }

    getSortIcon(value: string) {
        if (this.sort_ === value + "-asc") {
            return "$fa-sort-down";
        } else if (this.sort_ === value + "-desc") {
            return "$fa-sort-up";
        }
        return "$fa-sort";
    }

    getHeadClass() {
        return {
            hide: this.hideDefaultHeader,
        };
    }

    beforeMount() {
        this.random = (Math.random() + 1).toString(36).substring(7);
    }

    mounted() {
        this.$nextTick(() => {
            const div = document.querySelector(`#infinite-list-${this.random}`);

            div.addEventListener(
                "scroll",
                () => {
                    if (Math.abs(div.scrollHeight - div.clientHeight - div.scrollTop) < 1) {
                        this.loadMore();
                    }
                },
                {
                    passive: true,
                },
            );
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Shift") {
                this.majPress = true;
            }
            if (event.key === "Meta" || event.key === "Control") {
                this.ctrlPress = true;
            }
        });
        document.addEventListener("keyup", (event) => {
            if (event.key === "Shift") {
                this.majPress = false;
            }
            if (event.key === "Meta" || event.key === "Control") {
                this.ctrlPress = false;
            }
        });

        this.setSort();
    }

    loadMore(newPoolSize?: number) {
        if (this.virtualScroll) {
            this.poolSize = newPoolSize || this.poolSize + this.rowToShow;
            this.$emit("load-more");
        }
    }

    getCellClasses(header: Header = null) {
        if (header) {
            return {
                "vertical-sticky": header.verticalSticky,
                "vertical-sticky-end": header.verticalStickyEnd,
                // "dense": this.dense,
                // "x-dense": this.xDense,
            };
        }
        return {
            // "dense": this.dense,
            // "x-dense": this.xDense,
        };
    }

    getSum(value: string) {
        if (this.itemKeysSelected.length) {
            return this.itemsSelected.reduce((acc, item) => {
                return acc + +item[value];
            }, 0);
        }
        return 0;
    }

    selectAll() {
        console.log("selectAll");
        if (this.itemLength) {
            this.$emit("selectAll");
        }
        if (this.itemKeysSelected.length !== 0) {
            this.itemKeysSelected = [];
        } else {
            this.itemKeysSelected = this.filtredItems
                .filter((item) => this.cbDisplayCondition(item))
                .map((item) => item[this.itemKey]);
        }
    }

    clearFilter(value) {
        this.filter[value] = "";
        this.filters[value] = false;
    }

    isSelected(item) {
        if (!item || item[this.itemKey] === undefined || item[this.itemKey] === null) {
            return false;
        }
        return this.itemKeysSelected.includes(item[this.itemKey]);
    }

    onClick(item) {
        // if (this.showSelect && (this.ctrlPress || this.majPress))  {
        if (this.showSelect && this.ctrlPress) {
            return this.addRemoveItem(item, this.getIndex(item));
        }
        this.$emit("clickRow", item);
    }

    isEqual(a, b) {
        return a[this.itemKey] === b[this.itemKey];
    }

    show(e, item) {
        e.preventDefault();
        this.showMenu = false;
        this.x = e.clientX;
        this.y = e.clientY;
        this.selectedMenuItem = item;
        this.$nextTick(() => {
            this.showMenu = true;
        });
    }

    closeMenu() {
        this.showMenu = false;
    }

    log(att) {
        console.log("att", att);
    }

    @Watch("value", { deep: true })
    onValueChange() {
        if (this.value.toString() !== this.itemKeysSelected.toString()) {
            this.itemKeysSelected = this.value.map((it) => it[this.itemKey]);
        }
    }

    @Watch("itemKeysSelected", { deep: true })
    onitemKeysSelectedChange() {
        this.value = this.itemKeysSelected;
    }

    @Watch("items", { deep: true })
    onItemsChange() {
        this.poolSize = 25;
    }

    @Watch("sortBy", { deep: true })
    @Watch("sortDesc", { deep: true })
    setSort() {
        if (this.sortBy?.length) {
            if (this.sortDesc?.length) {
                this.sort_ = `${this.sortBy[0]}-${this.sortDesc[0]}`;
            } else {
                this.sort_ = `${this.sortBy[0]}-asc`;
            }
        } else {
            this.sort_ = "";
        }
    }

    // vars and methods for direct scroll to the the first/last row of the table
    isScrollToBtnVisible = false;
    scrollToInProgress = false;
    displayScrollToBtn() {
        if (this.scrollToBtnConfig != null) this.isScrollToBtnVisible = true;
    }
    hideScrollToBtn() {
        this.isScrollToBtnVisible = false;
    }
    /** Function to scroll directly to the first/last row */
    scrollTo(direction: "top" | "bottom") {
        const tableHtmlElement = document.querySelector(`#infinite-list-${this.random}`);

        if (direction === "top") {
            const tableFirstRow: HTMLElement = tableHtmlElement?.querySelector("tbody tr");
            if (tableFirstRow) tableFirstRow.scrollIntoView({ behavior: "smooth", inline: "end" });
        } else {
            const from = this.poolSize;
            const step = this.rowToShow;
            const wait = this.rowToShow * 15;
            const total = this.itemLength || this.items.length;

            this.scrollToInProgress = true;

            /** Recursive function to load items step by step until the total */
            const loadByStep = (from: number, step: number, wait: number, total: number) => {
                let nbItemsToLoad = from + step;
                if (nbItemsToLoad > total) nbItemsToLoad = total;
                this.loadMore(nbItemsToLoad);
                setTimeout(() => {
                    if (nbItemsToLoad < total) {
                        loadByStep(nbItemsToLoad, step, wait, total);
                    } else {
                        const tableBody: HTMLElement = tableHtmlElement.querySelector("tbody");
                        if (tableBody) {
                            const nbRows = tableBody.childElementCount;
                            const endTabRow = tableBody.children.item(nbRows - 15);
                            if (endTabRow) endTabRow.scrollIntoView({ behavior: "smooth" });
                            this.scrollToInProgress = false;
                        }
                    }
                }, wait);
            };

            loadByStep(from, step, wait, total);
        }
    }
}

type Header = {
    name: string;
    value: string;
    verticalSticky: boolean;
    verticalStickyEnd: boolean;
    align: "center" | "left" | "right" | "justify" | "char";
    sum: boolean;
    sortable: boolean;
    filterable: {
        type: "startwith" | "includes" | "equals";
        options: any;
    };
    editable: boolean;
    width: string;
    text?: string;
    title?: string;
    select: boolean;
};

export default toNative(ossDataTable2);
</script>

<style>
.table {
    border-radius: 15px;
    width: 100%;
    color: #212529;
    margin-bottom: 0;
    background: #fff;
    border-spacing: 0;
    border-collapse: collapse;
}

.table .hide {
    display: none;
}

.table .header {
    position: sticky;
    top: 0;
}

.table .vertical-sticky {
    position: sticky;
    left: 0;
}

.table thead tr .vertical-sticky {
    z-index: 2;
}

.table tfoot tr .vertical-sticky {
    z-index: 2;
}

.table .vertical-sticky-end {
    position: sticky;
    right: 0;
}

.table thead tr .vertical-sticky-end {
    z-index: 2;
}

.table tfoot tr .vertical-sticky-end {
    z-index: 2;
}

.table th,
.table td {
    height: 48px;
    margin: 0px;
    padding: 0px 8px !important;
}

.table.dense tr th,
.table.dense tr td,
.table.dense th,
.table.dense td {
    height: 32px;
}

.table.x-dense tr,
.table.x-dense tr th,
.table.x-dense tr td,
.table.x-dense th {
    height: 26px;
    max-height: 26px;
}

.table-fixed-header thead,
.table-fixed-header thead tr {
    position: relative;
    top: 0;
}

.table-fixed-footer tfoot,
.table-fixed-footer tfoot tr {
    position: sticky;
    bottom: 0;
    background-color: #fff;
    z-index: 5;
}

.table tr th {
    background-color: #fff;
    white-space: nowrap;
    padding: 0px 10px;
}

.table tr td {
    background: inherit;
}

.table tbody tr {
    border-top: 1px solid #eaeaea;
    background-color: #fff;
}

.table tfoot {
    border-top: 1px solid #eaeaea;
}

.table tfoot tr {
    border: none;
}

.table.table-striped tbody tr:nth-child(2n),
table.striped tr:nth-child(2n) {
    background-color: #fff;
    border: none;
}

.table.table-striped tbody tr:nth-child(2n + 1),
table.striped tr:nth-child(2n + 1) {
    background-color: #fef8ee;
    border: none;
}

.table.table-hover tbody tr {
    transition:
        border-color 0.3s,
        background 0.3s;
}

.table.table-hover tbody tr.row-selected {
    background-color: #fef0d0;
}

.table.table-hover tbody tr:hover {
    background: #ffe8b5 !important;
}

.table thead td,
.table thead th {
    white-space: nowrap;
    padding: 0px 8px !important;
}

.table .filter-menu {
    background: #fff;
    padding: 0.5em;
}

.table .input-table {
    height: 100%;
}

.table .hide {
    display: none;
}

.fixed-footer {
    position: sticky;
    inset-block-end: 0;
    background: #fff;
}

.fixed-footer th,
.fixed-footer td {
    background: #fff;
}

/* oss-scroll-to buttons */
.scroll-to-top-btn,
.scroll-to-bottom-btn {
    position: absolute;
    top: 50%;
    right: -6px;
    z-index: 5;
    height: 36px !important;
    font-size: 1.2rem;
}
.scroll-to-top-btn::before,
.scroll-to-bottom-btn::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 3px solid #666;
    border-radius: 50%;
}
.scroll-to-top-btn {
    transform: translateY(-12px) rotateZ(90deg) scale(0.6);
}
.scroll-to-bottom-btn {
    transform: translateY(12px) rotateZ(270deg) scale(0.6);
}
</style>
